export default __webpack_public_path__ + "static/photo-melissa-565d53e276aa9b6658d09c4032999f93.webp";